<template>
  <FormsBase />
</template>

<script>
import FormsBase from '../components/Benefits/FormsBase.vue';

export default {
  name: 'RegistrationView',

  components: {
    FormsBase,
  },
};
</script>
